import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../store";
import { PaymentConfiguration } from "../../../types/PaymentConfigurationTypes";
import { toast } from "react-toastify";
import { createPaymentConfiguration, fetchPaymentConfiguration, updatePaymentConfiguration } from "./paymentConfigurationAsyncThunk";
import { RequestResults } from "../../common/RequestStatus";


interface PaymentConfigurationState {
    data: PaymentConfiguration;
    status: RequestResults;
    loading: RequestResults;
    error: string | null;
}

const initialState: PaymentConfigurationState = {
    data: {} as PaymentConfiguration,
    status: RequestResults.idle,
    loading: RequestResults.idle,
    error: null,
};

// Slice
const paymentConfigurationSlice = createSlice({
    name: "paymentConfiguration",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchPaymentConfiguration.pending, (state) => {
                state.status = RequestResults.pending;
                state.error = null;
            })
            .addCase(fetchPaymentConfiguration.fulfilled, (state, action: PayloadAction<PaymentConfiguration>) => {
                state.status = RequestResults.success;
                state.data = action.payload;
            })
            .addCase(fetchPaymentConfiguration.rejected, (state, action) => {
                state.status = RequestResults.failed;
                toast.error(action.payload || "Failed to fetch payment configuration");
                state.error = action.payload || "Failed to fetch payment configuration";
            });
        builder
            .addCase(createPaymentConfiguration.pending, (state) => {
                state.loading = RequestResults.pending;
            })
            .addCase(createPaymentConfiguration.fulfilled, (state, action: PayloadAction<PaymentConfiguration>) => {
                state.data = action.payload;
                state.loading = RequestResults.success;
            })
            .addCase(createPaymentConfiguration.rejected, (state, action) => {
                state.loading = RequestResults.failed;
                toast.error(action.payload || "Failed to add payment configuration");
                state.error = action.payload || "Failed to add payment configuration";
            });
        builder
            .addCase(updatePaymentConfiguration.pending, (state) => {
                state.loading = RequestResults.pending;
            })
            .addCase(updatePaymentConfiguration.fulfilled, (state, action: PayloadAction<PaymentConfiguration>) => {
                state.data = action.payload;
                state.loading = RequestResults.success;
            })
            .addCase(updatePaymentConfiguration.rejected, (state, action) => {
                toast.error(action.payload || "Failed to update payment configuration");
                state.error = action.payload || "Failed to update payment configuration";
                state.loading = RequestResults.failed;
            });
    },
});

export const selectPaymentConfigurations = (state: RootState) => state.paymentConfiguration;

export default paymentConfigurationSlice.reducer;
